import store from '@/store/'

// eslint-disable-next-line no-unused-vars
export default function guest({ from, next, router, to }) {
  // console.log('middleware/guest | from', from)
  // console.log('middleware/guest | to', to)

  if (store.getters['auth/is_auth']) {
    return router.push({ name: 'dashboard' })
  }

  return next()
}
